// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-card {
  padding-left: 0;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 30px;
}

.mat-card-header .mat-card-title {
  margin: 0;
  font-size: 24px;
}

.card-header {
  background-color: #fbf9ec;
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap to the next line */
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.icon-add {
  float: right;
  background-color: #3f51b5;
  color: #fff;
  font-size: 1.1em;
  margin: 10px 30px;
}

.icon-text {
  font-family: "Open Sans";
  font-size: 1em;
  margin-left: 5px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/ministry/municipalities/municipalities.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AADF;;AAGA;EACE,SAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;EACA,aAAA;EACA,eAAA,EAAA,yCAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,YAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAAF","sourcesContent":["\r\n\r\n.mat-card{\r\n  padding-left: 0;\r\n  padding-top: 0;\r\n  padding-right: 0;\r\n  padding-bottom: 30px;\r\n}\r\n.mat-card-header .mat-card-title{\r\n  margin: 0;\r\n  font-size: 24px;\r\n}\r\n\r\n.card-header {\r\n  background-color: #fbf9ec;\r\n  display: flex;\r\n  flex-wrap: wrap; /* Allow items to wrap to the next line */\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px;\r\n}\r\n\r\n.icon-add{\r\n  float:right;\r\n  background-color: #3f51b5;\r\n  color: #fff;\r\n  font-size: 1.1em;\r\n  margin: 10px 30px;\r\n}\r\n\r\n.icon-text{\r\n  font-family: \"Open Sans\";\r\n  font-size: 1em;\r\n  margin-left: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
